function money(cents, prefix) {
  const major = Math.round(Number(cents || 0) / 100);
  return `${prefix}${major.toLocaleString('en-US')}`;
}

function slotConfig(root) {
  try {
    return JSON.parse(root.getAttribute('data-slots') || '{}');
  } catch {
    return {};
  }
}

function bootGift(root) {
  if (!root || root.dataset.booted === '1') return;
  root.dataset.booted = '1';

  const prefix = root.getAttribute('data-money-prefix') || 'Rs ';
  const notes = {
    today: root.getAttribute('data-note-today') || '',
    tomorrow: root.getAttribute('data-note-tomorrow') || '',
    pick: root.getAttribute('data-note-pick') || '',
  };
  const slots = slotConfig(root);
  const words = {
    cake: 'cake',
    choc: 'chocolate',
    teddy: 'teddy',
    balloon: 'balloons',
    candle: 'candle',
    card: 'card',
    extra: 'extra',
  };

  const nameEl = root.querySelector('[data-gift-name]');
  const imgEl = root.querySelector('[data-gift-img]');
  const emptyEl = root.querySelector('[data-gift-empty]');
  const totalEl = root.querySelector('[data-gift-total]');
  const brkEl = root.querySelector('[data-gift-brk]');
  const slotsEl = root.querySelector('[data-gift-slots]');
  const noteEl = root.querySelector('[data-gift-note]');
  const dateRow = root.querySelector('[data-gift-date-row]');
  const dateInput = root.querySelector('[data-gift-date]');
  const chips = root.querySelector('[data-when-chips]');
  const buyBtn = root.querySelector('[data-gift-buy]');
  const errorEl = root.querySelector('[data-gift-error]');
  const items = [...root.querySelectorAll('[data-addon]')];
  const badges = [...root.querySelectorAll('[data-badge]')];

  const state = {
    title: root.getAttribute('data-base-title') || 'Your bouquet',
    cents: Number(root.getAttribute('data-base-cents') || 0),
    image: root.getAttribute('data-base-image') || '',
    variantId: root.getAttribute('data-base-variant') || '',
    when: 'today',
    slot: '',
  };

  function setPressed(node, on) {
    node.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function applyCutoff() {
    items.forEach((it) => {
      const late = it.getAttribute('data-cutoff') === '1' && state.when === 'today';
      it.dataset.late = late ? '1' : '0';
      it.setAttribute('aria-disabled', late ? 'true' : 'false');
      const priceEl = it.querySelector('[data-addon-price]');
      if (!priceEl) return;
      if (late) {
        setPressed(it, false);
        priceEl.textContent = it.getAttribute('data-late-label') || 'Not today — from tomorrow';
      } else {
        priceEl.textContent = it.getAttribute('data-price-label') || '';
      }
    });
  }

  function drawSlots() {
    if (!slotsEl) return;
    const rows = slots[state.when] || slots.pick || [];
    slotsEl.replaceChildren();
    rows.forEach((row) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'artink-gift__slot';
      btn.textContent = row.label;
      if (!row.on) btn.disabled = true;
      const selected = row.on && (state.slot === row.label || (!state.slot && row.on));
      if (selected && !state.slot) state.slot = row.label;
      setPressed(btn, state.slot === row.label && row.on);
      btn.addEventListener('click', () => {
        state.slot = row.label;
        [...slotsEl.children].forEach((child) => setPressed(child, child === btn));
        recalc();
      });
      slotsEl.appendChild(btn);
    });
    if (noteEl) noteEl.innerHTML = notes[state.when] || '';
    if (dateRow) dateRow.hidden = state.when !== 'pick';
    if (state.when === 'pick' && dateInput && !dateInput.value) {
      const d = new Date();
      d.setDate(d.getDate() + 7);
      dateInput.value = d.toISOString().slice(0, 10);
      dateInput.min = new Date().toISOString().slice(0, 10);
      const max = new Date();
      max.setDate(max.getDate() + Number(root.getAttribute('data-max-days') || 60));
      dateInput.max = max.toISOString().slice(0, 10);
    }
  }

  function recalc() {
    let total = state.cents;
    const kinds = {};
    const labels = [];
    items.forEach((it) => {
      if (it.disabled || it.getAttribute('aria-pressed') !== 'true' || it.dataset.late === '1') return;
      total += Number(it.getAttribute('data-cents') || 0);
      const key = it.getAttribute('data-k');
      kinds[key] = true;
      labels.push(it.getAttribute('data-name') || '');
    });
    badges.forEach((b) => b.classList.toggle('is-on', !!kinds[b.getAttribute('data-for')]));
    if (totalEl) totalEl.textContent = money(total, '');
    if (brkEl) {
      const when =
        state.when === 'today'
          ? 'delivered today'
          : state.when === 'tomorrow'
            ? 'delivered tomorrow'
            : 'date to choose';
      const extras = Object.keys(kinds)
        .map((k) => words[k] || k)
        .filter(Boolean);
      brkEl.textContent = [state.title, ...extras, when].filter(Boolean).join(' · ');
    }
    if (nameEl) nameEl.textContent = state.title;
    if (imgEl) {
      if (state.image) {
        imgEl.src = state.image;
        imgEl.alt = state.title;
        imgEl.hidden = false;
        if (emptyEl) emptyEl.hidden = true;
      } else {
        imgEl.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
      }
    }
    if (buyBtn) buyBtn.disabled = !state.variantId;
  }

  function selectBouquet(detail) {
    if (!detail) return;
    state.title = detail.title || state.title;
    state.cents = Number(detail.cents || 0);
    state.image = detail.image || '';
    state.variantId = String(detail.variantId || '');
    recalc();
  }

  chips?.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-slot]');
    if (!chip) return;
    state.when = chip.getAttribute('data-slot');
    state.slot = '';
    chips.querySelectorAll('[data-slot]').forEach((node) => setPressed(node, node === chip));
    applyCutoff();
    drawSlots();
    recalc();
  });

  items.forEach((it) => {
    it.addEventListener('click', () => {
      if (it.dataset.late === '1') return;
      setPressed(it, it.getAttribute('aria-pressed') !== 'true');
      recalc();
    });
  });

  dateInput?.addEventListener('change', recalc);

  const onGiftSelect = (event) => selectBouquet(event.detail);
  document.addEventListener('artink:gift-select', onGiftSelect);

  buyBtn?.addEventListener('click', async () => {
    if (!state.variantId || buyBtn.getAttribute('aria-busy') === 'true') return;
    buyBtn.setAttribute('aria-busy', 'true');
    if (errorEl) errorEl.hidden = true;
    const properties = {
      Delivery:
        state.when === 'pick' && dateInput?.value
          ? dateInput.value
          : state.when === 'tomorrow'
            ? 'Tomorrow'
            : 'Today',
      Slot: state.slot || '',
    };
    const addonNames = items
      .filter((it) => !it.disabled && it.getAttribute('aria-pressed') === 'true' && it.dataset.late !== '1')
      .map((it) => it.getAttribute('data-name'))
      .filter(Boolean);
    if (addonNames.length) properties.Addons = addonNames.join(', ');

    const payload = {
      items: [
        {
          id: Number(state.variantId),
          quantity: 1,
          properties,
        },
      ],
    };
    items.forEach((it) => {
      if (it.disabled || it.getAttribute('aria-pressed') !== 'true' || it.dataset.late === '1') return;
      const id = it.getAttribute('data-variant');
      if (id) payload.items.push({ id: Number(id), quantity: 1 });
    });

    try {
      const url = window.Theme?.routes?.cart_add_url || '/cart/add.js';
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Could not add to cart');
      }
      if (window.ArtinkCart?.openDropdown) {
        await window.ArtinkCart.openDropdown();
      } else if (window.ArtinkCart?.refresh) {
        await window.ArtinkCart.refresh();
      }
    } catch (error) {
      console.warn('[artink-gift]', error);
      if (errorEl) {
        errorEl.textContent = error.message || 'Could not add to cart';
        errorEl.hidden = false;
      }
    } finally {
      buyBtn.removeAttribute('aria-busy');
    }
  });

  applyCutoff();
  drawSlots();
  recalc();

  root._artinkGiftCleanup = () => {
    document.removeEventListener('artink:gift-select', onGiftSelect);
    root.dataset.booted = '0';
  };
}

function initAll() {
  document.querySelectorAll('[data-artink-gift]').forEach(bootGift);
}

initAll();
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-artink-gift]').forEach(bootGift);
});
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-artink-gift]').forEach((root) => {
    root._artinkGiftCleanup?.();
  });
});
